// Dependecies
import React from 'react'

const InputField = (props) => {
  return (
    <div className={`flex flex-col items-start w-full ${props.overrideStyles}`}>
      <label htmlFor={props.for} className={`${props.inputRequired ? 'flex' : 'hidden'} items-center text-black opacity-60 mb-2 font-normal`}>{props.labelText} <span className='text-red-600 ml-1'>*</span></label>
      <input id={props.for} name={props.name} type={props.inputType} className='border border-[#161C33] rounded-sm px-3 py-1 w-full' required={props.inputRequired} placeholder={props.placeholder} defaultValue={props.value} />
    </div>
  )
}

export default InputField